import { render, staticRenderFns } from "./AddOrgObject.vue?vue&type=template&id=76145fe7"
import script from "./AddOrgObject.vue?vue&type=script&lang=js"
export * from "./AddOrgObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports